<template>
  <div class="container">
     <div class="header">
        <div class="left">
           共 1 {{unit}} <span v-if="worksSize">（{{ worksSize }}）</span>
        </div>
     </div>
     <div class="content">
        <div class="item-box" >
          <div class="imgBox">
              <el-image
                v-if="resourceType==1"
                class="imgview"
                fit="contain"
                :src="resourceUrl" 
                :preview-src-list="[resourceUrl]">
              </el-image>
              <video class="video-mask" @click="handlePlayVideo(resourceUrl)" width="100%" height="100%" v-else :src="resourceUrl"></video>
              <i v-if="resourceType != 1" class="el-icon-video-play play-icon"></i>
            </div>
        </div>
        
     </div>
     <videoPlay v-if="resourceType==3" :visible.sync="dialogVisible" :videoUrl="videoUrl"></videoPlay>
  </div>
</template>

<script>
import videoPlay from './videoPlay.vue';
  export default {
    name: 'resoureDetail',
    components: {
      videoPlay
    },
    props: {
      resourceType:{
        type: String,
        default: '1'
      },
      resourceUrl:{
        type: String,
        default: ''
      },
      worksSize:{
        type: String,
        default: ''
      }
    },
    data() {
      return {
        fileList: [],
        dialogVisible: false,
        videoUrl: '',
      }
    },
    computed: {
      // totalSize() {
      //   let size = 0;
      //   this.fileList.forEach(item => {
      //     size += item.size;
      //   });
      //   let value = Math.floor((size/1024/1024)*100)/100;
      //   return value + ' MB';
      // },
      unit() {
        return this.resourceType==1?'张':'个';
      }
    },
    methods: {
      handlePlayVideo(url){
        this.videoUrl = url;
        this.dialogVisible = true;
      }
    },

  }
</script>

<style lang="scss" scoped>
.container{
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    font-weight: 400;
    font-size: 14px;
    .left{
      color: #999999;
    }
    .right{
      color: #4E89FF;
      span{
        margin-right: 10px;
        cursor: pointer;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
}
.content {
  display: flex;
  flex-wrap: wrap;
  
  .item-box {
    width: 100%;
    margin-right: 10px;
    margin-bottom: 10px;
    height: 253px;
    padding: 5px;
    background: #F6F9FF;
    border-radius: 3px;
    border: 1px solid #F6F9FF;
    &:last-child {
      margin-right: 0;
    }
    .check-box{
      margin-bottom: 9px;
      margin-left: 10px
    }
    .imgBox {
      width: 100%;
      height: 100%;
      position: relative;
      .video-mask{
        cursor: pointer;
      }
      .play-icon{
        position: absolute;
        font-size: 40px;
        background:linear-gradient(180deg, #6877FF 0%, #4BBEFF 100%);
        border-radius: 50%;
        color: #fff;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
      }
      .imgview{
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .title{
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      margin-top: 9px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

    }
   
  }
}
</style>